export const TIME_TO_CLOSE = 6000;

export type MessageProps = {
  title: string;
  subtitle: string;
};
